import React from "react";
import { DisputeStatus } from "../../../../../utils/constants";
import { useFormData } from "../../../../../helpers/FormDataProvider";
import { useConfiguration } from "../../../../../services/ConfigurationProvider";
import {
  getGovernmentPassenger,
  getInfantPassenger,
  getDiplomatsPassenger,
  getMilitaryPassenger,
} from "../../../../../utils/configUtils";

const PassengerCountDisplay = ({ flightPlanDetail }) => {
  const { userData } = useFormData();
  const { configurationData } = useConfiguration();

  const governmentPassengerEnabled = getGovernmentPassenger(configurationData);
  const diplomatsPassengerEnabled = getDiplomatsPassenger(configurationData);
  const militaryPassengerEnabled = getMilitaryPassenger(configurationData);
  const infantPassengerEnabled = getInfantPassenger(configurationData);

  const getPassengerCountClassName = () => {
    if (flightPlanDetail?.disputeStatus === DisputeStatus.AA_FORCED_BMS_COUNT) {
      return "passenger-count-accepted";
    }
    if (
      flightPlanDetail?.disputeStatus ===
      DisputeStatus.AA_ACCEPTED_AIRLINE_COUNT
    ) {
      return "passenger-count-rejected";
    }
    if (flightPlanDetail?.disputeStatus === DisputeStatus.RAISED) {
      return "passenger-count-rejected";
    }
    return "";
  };

  const getStatusDisplayInfo = () => {
    const isAccept =
      flightPlanDetail?.disputeStatus === DisputeStatus.AA_FORCED_BMS_COUNT;
    const isReject =
      flightPlanDetail?.disputeStatus ===
      DisputeStatus.AA_ACCEPTED_AIRLINE_COUNT;

    return {
      isAccept,
      isReject,
    };
  };

  const statusInfo = getStatusDisplayInfo();

  return (
    <div className="edit-flight-passenger-count-container">
      <div className="passenger-count-display-container">
        <div className="passenger-count-table">
          <div className="passenger-count-table-header">
            <div className="passenger-count-table-cell">
              BMS Passengers Count
            </div>
            <div className="passenger-count-table-cell">
              BMS Exempted Passengers
            </div>
            {infantPassengerEnabled && (  
            <div className="passenger-count-table-cell">Infant</div>
            )}
            {militaryPassengerEnabled && (
              <div className="passenger-count-table-cell">Military</div>
            )}
            {governmentPassengerEnabled && (
              <div className="passenger-count-table-cell">Government</div>
            )}
            {diplomatsPassengerEnabled && (
              <div className="passenger-count-table-cell">Diplomat</div>
            )}
          </div>
        </div>
        <div className="passenger-count-table-row">
          <div className="passenger-count-table-cell">
            <p className={getPassengerCountClassName()}>
              {userData.isAAUser
                ? flightPlanDetail?.scannedPassengerCount
                : flightPlanDetail?.acceptedPassengerCount}
            </p>
          </div>
          <div className="passenger-count-table-cell">
            <p className={getPassengerCountClassName()}>
              {userData.isAAUser
                ? flightPlanDetail?.exemptedPassengerCount
                : flightPlanDetail?.acceptedExemptedPassengerCount}
            </p>
          </div>
          {infantPassengerEnabled && (
          <div className="passenger-count-table-cell">
            <p className={getPassengerCountClassName()}>
              {userData.isAAUser
                ? flightPlanDetail?.scannedInfant
                : flightPlanDetail?.acceptedInfant}
            </p>
          </div>
          )}
          {militaryPassengerEnabled && (
            <div className="passenger-count-table-cell">
              <p className={getPassengerCountClassName()}>
                {userData.isAAUser
                  ? flightPlanDetail?.scannedMilitary
                  : flightPlanDetail?.acceptedMilitary}
              </p>
            </div>
          )}
          {governmentPassengerEnabled && (
            <div className="passenger-count-table-cell">
              <p className={getPassengerCountClassName()}>
                {userData.isAAUser
                  ? flightPlanDetail?.scannedGovernment
                  : flightPlanDetail?.acceptedGovernment}
              </p>
            </div>
          )}
          {diplomatsPassengerEnabled && (
            <div className="passenger-count-table-cell">
              <p className={getPassengerCountClassName()}>
                {userData.isAAUser
                  ? flightPlanDetail?.scannedDiplomats
                  : flightPlanDetail?.acceptedDiplomats}
              </p>
            </div>
          )}
        </div>
      </div>
      {(statusInfo.isAccept || statusInfo.isReject) && (
        <div className="dispute-status-indicators">
          <div className="status-item">
            <div className={`color-box ${"color-box-green"}`}></div>
            <span>Accept</span>
          </div>
          <div className="status-item">
            <div className={`color-box ${"color-box-red"}`}></div>
            <span>Reject</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default PassengerCountDisplay;
